<template>
  <localization :language="localizationLanguage">
    <intl :locale="locale">
      <Header @localeChange="onLocaleChange" @themeChange="onThemeChange" />
      <div class="content-wrapper">
        <div class="column menu">
          <MenuNavContainer :current-theme="currentTheme.toLowerCase()" />
        </div>
        <div class="column content">
          <div class="k-drawer-container k-drawer-mini k-drawer-push">
            <div class="card-container">
              <router-view
                  :localization-language="localizationLanguage"
                  :current-theme="currentTheme"
              ></router-view>
            </div>
          </div>
        </div>
      </div>
    </intl>
  </localization>
</template>

<script>
import Header from "../components/Header.vue";
import MenuNavContainer from "../components/MenuNavContainer";
import { enComponentMessages, enCustomMessages } from "../messages/en-US";
import { esComponentMessages, esCustomMessages } from "../messages/es";
import { frComponentMessages, frCustomMessages } from "../messages/fr";
import { ruComponentMessages, ruCustomMessages } from "../messages/ru-RU";

import {
  load,
  LocalizationProvider,
  IntlProvider,
  loadMessages,
} from "@progress/kendo-vue-intl";

import likelySubtags from "cldr-core/supplemental/likelySubtags.json";
import currencyData from "cldr-core/supplemental/currencyData.json";
import weekData from "cldr-core/supplemental/weekData.json";

import numbers from "cldr-numbers-full/main/es/numbers.json";
import caGregorian from "cldr-dates-full/main/es/ca-gregorian.json";
import dateFields from "cldr-dates-full/main/es/dateFields.json";
import timeZoneNames from "cldr-dates-full/main/es/timeZoneNames.json";
import esNumbers from "cldr-numbers-full/main/es/numbers.json";
import esCurrencies from "cldr-numbers-full/main/es/currencies.json";

import frNumbers from "cldr-numbers-full/main/fr/numbers.json";
import frCaGregorian from "cldr-dates-full/main/fr/ca-gregorian.json";
import frDateFields from "cldr-dates-full/main/fr/dateFields.json";
import frTimeZoneNames from "cldr-dates-full/main/fr/timeZoneNames.json";
import frCurrencies from "cldr-numbers-full/main/fr/currencies.json";

// Добавляем импорт русской локализации
import ruNumbers from "cldr-numbers-full/main/ru/numbers.json";
import ruCaGregorian from "cldr-dates-full/main/ru/ca-gregorian.json";
import ruDateFields from "cldr-dates-full/main/ru/dateFields.json";
import ruTimeZoneNames from "cldr-dates-full/main/ru/timeZoneNames.json";
import ruCurrencies from "cldr-numbers-full/main/ru/currencies.json";

import useUser from '../composables/user';
import {useRouter} from 'vue-router';

const {loggedIn} = useUser();
const router = useRouter();

load(
    likelySubtags,
    currencyData,
    weekData,
    numbers,
    caGregorian,
    dateFields,
    timeZoneNames,
    esNumbers,
    esCurrencies,
    frNumbers,
    frCaGregorian,
    frDateFields,
    frTimeZoneNames,
    frCurrencies,
    ruNumbers,
    ruCaGregorian,
    ruDateFields,
    ruTimeZoneNames,
    ruCurrencies
);

loadMessages(enCustomMessages, "English");
loadMessages(enComponentMessages, "English");
loadMessages(esCustomMessages, "Spanish");
loadMessages(esComponentMessages, "Spanish");
loadMessages(frCustomMessages, "French");
loadMessages(frComponentMessages, "French");
loadMessages(ruCustomMessages, "Russian");
loadMessages(ruComponentMessages, "Russian");

export default {
  name: "app",
  components: {
    Header,
    MenuNavContainer,
    localization: LocalizationProvider,
    intl: IntlProvider,
  },
  mounted() {
    if (!loggedIn()) {
      router.push({name: 'login'});
    }
  },
  methods: {
    onLocaleChange(e) {
      this.localizationLanguage = e.language;
    },
    onThemeChange(e) {
      this.currentTheme = e;
    },
  },
  computed: {
    locale() {
      if (this.localizationLanguage === "Spanish") {
        return "es";
      }

      if (this.localizationLanguage === "Russian") {
        return "ru";
      }


      if (this.localizationLanguage === "French") {
        return "fr";
      }

      return "ru";
    },
  },
  data() {
    return {
      localizationLanguage: "Russian",
      currentTheme: "Default",
    };
  },
}
</script>

